import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: 'Mic',
      label: 'Start Recording',
      description: 'Begin a new recording session',
      color: 'bg-accent',
      onClick: () => navigate('/audio-file-management')
    },
    {
      icon: 'Calendar',
      label: 'View Schedule',
      description: 'Check your recording schedule',
      color: 'bg-secondary',
      onClick: () => navigate('/voice-actor-assignment-interface')
    },
    {
      icon: 'TrendingUp',
      label: 'Performance',
      description: 'View your analytics',
      color: 'bg-success',
      onClick: () => navigate('/voice-actor-performance-analytics')
    },
    {
      icon: 'Bell',
      label: 'Notifications',
      description: 'Manage notification preferences',
      color: 'bg-primary',
      onClick: () => navigate('/voice-actor-portal-dashboard?tab=notifications')
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {actions?.map((action, index) => (
        <button
          key={index}
          onClick={action?.onClick}
          className="flex flex-col items-center gap-3 p-6 bg-card border border-border rounded-lg hover:shadow-lg hover:border-primary transition-all duration-200 group"
        >
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${action?.color} group-hover:scale-110 transition-transform`}>
            <Icon name={action?.icon} size={24} color="white" />
          </div>
          <span className="text-sm font-medium text-foreground text-center">
            {action?.label}
          </span>
        </button>
      ))}
    </div>
  );
};

export default QuickActions;